<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" :placeholder="'名称'"
                  v-model="listQuery.key">
          <el-button slot="append" icon="el-icon-caret-bottom" @click="dialogQueryVisible = true"></el-button>
          <i slot="suffix" class="el-input__icon el-icon-search" @click="handleFilter"></i>
        </el-input>
        <el-button type="primary" icon="el-icon-refresh" size="mini" class="filter-item" @click="handleClear">重置
        </el-button>
        <permission-btn moduleName='sysFields' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <el-row class="fh">
        <el-col :span="10" class="fh ls-border">
          <el-card shadow="never" class="card-body-none fh" style="overflow-y: auto">
            <div slot="header" class="clearfix">
              <el-button type="text" style="padding: 0 11px" @click="getAllMenus">所有菜单>></el-button>
            </div>
            <tree-table highlight-current-row :data="modulesTree" :columns="columns" @row-click="treeClick"
                        border></tree-table>
          </el-card>
        </el-col>
        <el-col :span="14" class="fh">
          <div class="bg-white fh">
            <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit
                      highlight-current-row
                      style="width: 100%;" class="main-table" height="calc(100vh - 200px)" @row-click="rowClick"
                      @selection-change="handleSelectionChange" @sort-change="handleSortChange">
              <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->

              <el-table-column type="selection" align="center" width="55"></el-table-column>
              <template v-for="(headerItem,index) in headerList">
                <el-table-column v-if="headerItem.isSel" :key="index" :min-width="headerItem.width"
                                 :label="headerItem.description" :sortable="headerItem.isSort?'custom':false">
                  <template slot-scope="scope">
                    <select-type :isEdit="false" :typeId="headerItem.isSel"
                                 v-model="scope.row[headerItem.key]"></select-type>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="headerItem.key=='visible'" :key="index" :min-width="headerItem.width"
                                 :prop="headerItem.key" :label="headerItem.description" show-overflow-tooltip
                                 :sortable="headerItem.isSort?'custom':false">
                  <template slot-scope="scope">
                    <span
                      :class="scope.row.visible?'color-info':'color-danger'">{{ scope.row.visible ? "是" : "否" }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="headerItem.key=='isSort'" :key="index" :min-width="headerItem.width"
                                 :prop="headerItem.key" :label="headerItem.description" show-overflow-tooltip
                                 :sortable="headerItem.isSort?'custom':false">
                  <template slot-scope="scope">
                    <span
                      :class="scope.row.isSort?'color-info':'color-danger'">{{ scope.row.isSort ? "是" : "否" }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="headerItem.key=='isSel'" :key="index" :min-width="headerItem.width"
                                 :prop="headerItem.key" :label="headerItem.description" show-overflow-tooltip
                                 :sortable="headerItem.isSort?'custom':false">
                  <template slot-scope="scope">
                    <span>{{ scope.row.isSel }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="headerItem.type=='String'" :key="index" :min-width="headerItem.width"
                                 :prop="headerItem.key" :label="headerItem.description" show-overflow-tooltip
                                 :sortable="headerItem.isSort?'custom':false">
                </el-table-column>
                <el-table-column v-else :label="headerItem.description" :min-width="headerItem.width" :key="index"
                                 :sortable="headerItem.isSort?'custom':false" :prop="headerItem.key">
                  <template slot-scope="scope">
                    <span>{{ scope.row[headerItem.key] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
          </div>
        </el-col>
      </el-row>

      <el-dialog v-el-drag-dialog class="dialog-mini" width="60%" :title="textMap[dialogStatus]"
                 :visible.sync="dialogFormVisible" :close-on-click-modal='false'>
        <div style="height:calc(65vh); overflow:auto;">
          <el-form :rules="rules" ref="dataForm" :model="temp" label-position="right" label-width="100px">
            <el-tabs value="1">
              <el-tab-pane label="表格配置" name="1">
                <el-row>
                  <el-col :span="12">
                    <el-form-item :test11="'string'" size="small" :label="'字段名'" prop="name">
                      <el-input v-model="temp.name" maxlength="100"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'排序'" prop="sortNo">
                      <el-input-number v-model="temp.sortNo"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item :test11="'string'" size="small" :label="'标题'" prop="title">
                      <el-input v-model="temp.title" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'宽度'" prop="width">
                      <el-input-number v-model="temp.width"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'对齐方式'" prop="align">
                      <el-select class="filter-item" v-model="temp.align" placeholder="Please select">
                        <el-option v-for="item in  alignOptions" :key="item.key" :label="item.display_name"
                                   :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'是否显示'" prop="visible">
                      <el-switch v-model="temp.visible" :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'SelectType'" prop="isSel">
                      <el-input v-model="temp.isSel" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'是否排序'" prop="isSort">
                      <el-switch v-model="temp.isSort" :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'Tooltip'" prop="tooltip">
                      <el-switch v-model="temp.tooltip" :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'手机端显示'" prop="mobileVisible">
                      <el-switch v-model="temp.mobileVisible" :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'资源'" prop="moduleCode">
                      <el-input v-model="temp.moduleCode"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'字段类型'" prop="fieldTp">
                      <select-type :isEdit="true" typeId="SYS_FIELDTP" v-model="temp.fieldTp"></select-type>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'启用查询'" prop="isQuery">
                      <el-switch v-model="temp.isQuery" :active-value="true" :inactive-value="false"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'查询关系符'" prop="relation">
                      <select-type :isEdit="true" :multiple="true" typeId="SYS_FieldRelation" v-model="temp.relation"
                                   placeholder="请选择"></select-type>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="表单配置" name="2">
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'区域'" prop="formArea">
                      <el-input-number v-model="temp.formArea" :min="0"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'区域名称'" prop="formAreaNm">
                      <el-input v-model="temp.formAreaNm" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'是否可编辑'" prop="isEdit">
                      <el-switch v-model="temp.isEdit" :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'表单跨列'" prop="formSpan">
                      <el-input-number v-model="temp.formSpan" :min="0" :max="24"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'表单显示'" prop="formHide">
                      <el-switch v-model="temp.formHide" :active-value="true" :inactive-value="false">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'表单排序'" prop="formOrder">
                      <el-input-number v-model="temp.formOrder" :min="0"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'最大长度'" prop="formMaxlength">
                      <el-input-number v-model="temp.formMaxlength" :min="0"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'提示信息'" prop="formPlaceholder">
                      <el-input v-model="temp.formPlaceholder" maxlength="200"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item size="small" :label="'控件类型'" prop="formType">
                      <select-type :isEdit="true" typeId="SYS_FieldFormType" v-model="temp.formType"
                                   placeholder="请选择"></select-type>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item size="small" :label="'表单规则'" prop="formatter">
                      <el-input type="textarea" :autosize="{ minRows: 4}" v-model="temp.formatter"
                                maxlength="500"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>

            <!-- <el-form-item :test11="'string'" size="small" :label="'资源'" prop="moduleCode">
              <el-input v-model="temp.moduleCode" maxlength="100"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog class="dialog-mini" v-el-drag-dialog :title="'快速查询'" width="500px"
                 :visible.sync="dialogQueryVisible" :close-on-click-modal='false'>
        <div style="height:300px;overflow:auto;">
          <el-form ref="queryForm" label-position="right" label-width="60px">
            <el-form-item size="small" :label="'名称'">
              <el-input v-model="listQuery.key"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button size="mini" type="primary" @click="handleFilter">查询</el-button>
          <el-button size="mini" @click="handleClear">清空</el-button>
        </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import * as sysFields from '@/api/sysfields';
import * as login from '@/api/login';
import { listToTreeSelect } from '@/utils';
import treeTable from '@/components/TreeTable';
// import Treeselect from '@riophae/vue-treeselect'
import waves from '@/directive/waves'; // 水波纹指令
import Sticky from '@/components/Sticky';
import permissionBtn from '@/components/PermissionBtn';
import Pagination from '@/components/Pagination';
import elDragDialog from '@/directive/el-dragDialog';
import SelectType from '@/components/SelectType';
import { parseTime, IsNullOrEmpty } from '@/utils/index';

export default {
  name: 'sysFields',
  components: {
    Sticky,
    permissionBtn,
    Pagination,
    SelectType,
    // Treeselect,
    treeTable
  },
  directives: {
    waves,
    elDragDialog
  },
  data() {
    return {
      normalizer(node) {
        // treeselect定义字段
        return {
          label: node.code,
          id: node.code,
          children: node.children
        };
      },
      modulesTree: [], // 用户可访问到的所有模块组成的树
      currentModule: null, // 左边模块treetable当前选中的项
      isTreeSelect: false,
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        sort: 'sortNo',
        order: 'ascending',
        key: undefined,
        appId: undefined
      },
      columns: [
        // treetable的列名
        {
          text: '模块名称',
          value: 'name'
        },
        {
          text: '模块标识',
          value: 'code'
        }
      ],
      statusOptions: [
        { key: 1, display_name: '停用' },
        { key: 0, display_name: '正常' }
      ],
      alignOptions: [
        { key: 'left', display_name: 'left' },
        { key: 'center', display_name: 'center' },
        { key: 'right', display_name: 'right' }
      ],
      temp: {
        id: '', // Id
        moduleCode: '', // 资源
        name: '', // 字段名
        fieldTp: '', // 字段类型
        sortNo: '', // 排序
        title: '', // 标题
        width: '', // 宽度
        align: 'left', // 对齐方式
        visible: true, // 是否显示
        isSel: '', // 是否SelectType
        isSort: false, // 是否排序
        tooltip: false, // Tooltip
        formatter: '', // 格式化
        extendInfo: '', // 其他信息,防止最后加逗号，可以删除
        isEdit: true,
        mobileVisible: false
      },
      dialogFormVisible: false,
      dialogStatus: '',
      headerList: [],
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogQueryVisible: false,
      dialogPvVisible: false,
      pvData: [],
      rules: {
        appId: [{ required: true, message: '必须选择一个应用', trigger: 'change' }],
        moduleCode: [{ required: true, message: '必填', trigger: 'blur' }],
        sortNo: [{ required: true, message: '必填', trigger: 'blur' }],
        title: [{ required: true, message: '必填', trigger: 'blur' }],
        width: [{ required: true, message: '必填', trigger: 'blur' }],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      },
      downloadLoading: false
    };
  },
  filters: {
    filterInt(val) {
      switch (val) {
        case null:
          return '';
        case 1:
          return '状态1';
        case 2:
          return '状态2';
        default:
          return '默认状态';
      }
    },
    statusFilter(isFinish) {
      const statusMap = {
        0: 'color-info',
        1: 'color-success',
        2: 'color-danger',
        3: 'color-danger',
        4: 'color-danger'
      };
      return statusMap[isFinish];
    },
    dateFormat(datetitme) { // 时间格式化
      return datetitme ? parseTime(new Date(datetitme), '{y}-{m}-{d}') : '';
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    this.getModulesTree();
  },
  methods: {
    rowClick(row) {
      this.$refs.mainTable.clearSelection();
      this.$refs.mainTable.toggleRowSelection(row);
    },
    treeClick(data) {
      // 左侧treetable点击事件
      this.listQuery.key = data.code;
      this.temp.moduleCode = data.code;
      this.isTreeSelect = true;
      this.getList();
    },
    getAllMenus() {
      this.listQuery.key = '';
      this.isTreeSelect = false;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBtnClicked: function(domId) {
      // console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate();
          break;
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error'
            });
            return;
          }
          this.handleUpdate(this.multipleSelection[0]);
          break;
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error'
            });
            return;
          }
          this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleDelete(this.multipleSelection);
          }).catch(() => {
          });
          break;
        case 'btnAddField':
          if (IsNullOrEmpty(this.listQuery.key)) {
            this.$message({
              message: '只能选中一个模块批量添加字段',
              type: 'error'
            });
            return;
          }
          this.addField(this.listQuery.key);
          break;
        case 'btnchangeOtherField':
          if (IsNullOrEmpty(this.listQuery.key)) {
            this.$message({
              message: '只能选中一个模块批量隐藏字段',
              type: 'error'
            });
            return;
          }
          this.changeOtherField(this.listQuery.key);
          break;
        default:
          break;
      }
    },
    getList() {
      this.listLoading = true;
      sysFields.getList(this.listQuery).then(response => {
        this.list = response.data;
        const newruleitem = {};
        response.columnHeaders.forEach((item) => {
          item.key = item.key.substring(0, 1).toLowerCase() + item.key.substring(1);
          if (item.formatter) {
            newruleitem[item.key] = JSON.parse(item.formatter);
          }
        });
        this.rules = Object.assign(this.rules, newruleitem);
        this.headerList = response.columnHeaders.filter(u => u.browsable);
        this.total = response.count;
        this.listLoading = false;
      });
    },
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      login.getModules().then(response => {
        _this.modules = response.result.map(function(item, index, input) {
          return {
            sortNo: item.sortNo,
            id: item.id,
            name: item.name,
            parentId: item.parentId,
            code: item.code,
            url: item.url,
            cascadeId: item.cascadeId,
            isSys: item.isSys,
            iconName: item.iconName,
            status: item.status
          };
        });
        var modulestmp = JSON.parse(JSON.stringify(_this.modules));
        _this.modulesTree = listToTreeSelect(modulestmp);
        // console.log(_this.modulesTree)
      });
    },
    resetListQuery() {
      this.listQuery = { // 查询条件
        page: 1,
        limit: 20,
        sort: 'sortNo',
        order: 'ascending',
        key: '',
        appId: ''
      };
    },
    handleClear() { // 清空查询
      this.resetListQuery();
      this.getList();
    },
    handleFilter() {
      this.dialogQueryVisible = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getList();
    },
    handleModifyStatus(row, disable) { // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success'
      });
      row.disable = disable;
    },
    addField(code) {
      sysFields.addField(code).then(() => {
        this.$notify({
          title: '成功',
          message: '添加成功',
          type: 'success',
          duration: 2000
        });
        this.getList();
      }).catch(error => {
        this.$notify({
          title: '失败',
          message: '添加失败' + error,
          type: 'error',
          duration: 2000
        });
      });
    },
    changeOtherField(code) {
      sysFields.changeOtherField(code).then(() => {
        this.$notify({
          title: '成功',
          message: '隐藏成功',
          type: 'success',
          duration: 2000
        });
        this.getList();
      }).catch(error => {
        this.$notify({
          title: '失败',
          message: '隐藏失败' + error,
          type: 'error',
          duration: 2000
        });
      });
    },
    resetTemp() {
      var mdcode = null;
      if (this.isTreeSelect) {
        mdcode = this.temp.moduleCode;
      }
      this.temp = {
        id: '',
        moduleCode: '',
        name: '',
        fieldTp: '', // 字段类型
        sortNo: '1',
        title: '',
        width: '100',
        align: 'left',
        visible: true, // 是否显示
        isSel: '', // 是否SelectType
        isSort: false, // 是否排序
        tooltip: false, // Tooltip
        formatter: '',
        isEdit: true,
        mobileVisible: false,
        formHide: true,
        formArea: '1'
      };
      this.temp.moduleCode = mdcode;
    },
    handleCreate() { // 弹出添加框
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    createData() { // 保存提交
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          tempData.relation = tempData.relation && tempData.relation !== '' ? tempData.relation.join('/') : '';
          sysFields.add(tempData).then(() => {
            // this.list.unshift(this.temp)
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            });
            this.getList();
          });
        }
      });
    },
    handleUpdate(row) { // 弹出编辑框
      this.temp = Object.assign({}, row); // copy obj
      this.temp.relation = this.temp.relation && this.temp.relation !== '' && typeof (this.temp.relation) === 'string' ? this.temp.relation.split('/') : this.temp.relation;
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() { // 更新提交
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          tempData.relation = tempData.relation && tempData.relation.length > 0 ? tempData.relation.join('/') : '';
          sysFields.update(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            });
          });
        }
      });
    },
    handleDelete(rows) { // 多行删除
      sysFields.del(rows.map(u => u.id)).then(() => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        });
        rows.forEach(row => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    handleSortChange(column) {
      // console.log(column)
      this.listQuery.sort = column.prop;
      this.listQuery.order = column.order;
      this.handleFilter();
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
